export const MD_BREAKPOINT_TABLE_MIN_WIDTH = 885;
